import React, { PureComponent } from 'react';
import './article.component.style.css';
import { connect } from 'react-redux';
import { fetchAllArticles } from 'store/action/articles.action';
import ArticleTable from './articleTable.component';

class ArticleList extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      article: [],
    };
  }

  componentDidMount() {
    this._fetchAllArticles();
  }

  _onChangeState = event => this.setState({ state: event.currentTarget.value });

  _fetchAllArticles() {
    return fetchAllArticles()
      .then(({ data }) => {
        this.setState({
          article: data,
        });
      })
      .catch(e => {
        console.error(e);
        return this.setState({
          article: null,
        });
      });
  }

  render() {
    return (
      <div className="flex-column align-stretch">
        <div
          className="flex-column align-stretch"
          style={{ padding: '1% 10% 0% 10%' }}
        >
          <ArticleTable
            article={this.state.article}
            history={this.props.history}
          />
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    fetchAllArticles: () => dispatch(fetchAllArticles()),
  };
}

export default connect(mapDispatchToProps)(ArticleList);
